// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eventTypeContentContainer_zY91Z {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
	width: 95%;
	margin-left: 2.5%;
	gap: 13px;
}
.normalIcon_Qw66q {
	color: var(--_3c3a3a-color);
}
.infoIconTop_g3mau {
	margin-top: -40px;
	color: var(--_3c3a3a-color);
}
.columnContainer_LQIaE {
	display: flex;
	flex-direction: column;
	gap: 5px;
	position: relative;
}
.meetLink_Hw19T {
	position: absolute;
	top: 43px;
	left: 0;
	width: max-content;
	color: var(--_16c098-background);
}
.formTime_xPcaw {
	display: flex;
	align-items: center;
	gap: 5px;
	.innerContainer_Xs2_J {
		display: flex;
		flex-direction: column;
	}
	span {
		font-size: 12px;
		margin-left: 10px;
		color: var(--text-secondary);
	}
}
.formCalendar_mChgy {
	button {
		background: transparent;
		border: none;
		outline: none;
		color: var(--_10a37f-background);
		font-size: 16px;
		font-weight: 600;
		margin-left: 30px;
	}
}



.formMeet_JoQ0x {
	display: flex;
	align-items: center;
	gap: 12px;
	svg {
		min-width: 10px;
		min-height: 10px;
		width: 10px;
		height: 10px;
	}
	div svg {
		width: 30px;
		height: 30px;
		margin-right: -13px;
	}
}
.meetButton_k_7pm {
	background: var(--f5-background);
	color: var(--text-color-secondary);
	padding: 8px 14px;
	border-radius: 6px;
	transition: background 0.2s ease-in-out;
	&:hover {
		background-color: var(--_16c0982e-background);
	}
}
.meetButtonActive_FaR8S {
	background: var(--_10a37f-background);
	color: var(--_16c0982e-background);
	padding: 8px 14px;
	border-radius: 6px;
	transition: background 0.2s ease-in-out;
	&:hover {
		background-color: var(--_16c098-background);
	}
}
.formLocation_eaVs_ {
	display: flex;
	align-items: center;
	gap: 9px;
	svg {
		min-width: 22px;
		min-height: 22px;
		width: 22px;
		height: 22px;
	}
	button {
		background: var(--border-color);
		padding: 4px 12px;
		border-radius: 4px;
	}
}



.locationContainer_FKoG9 {
	display: flex;
	gap: 10px;
	margin-left: 30px;
}

.locationButton_ppm0j {
	display: flex;
	align-items: center;
	padding: 6px 12px;
	border: 1px solid #ddd;
	justify-content: center;
	border-radius: 8px;
	background-color: white;
	font-size: 14px;
	color: #666;
	cursor: pointer;
	font-weight: 600;
	transition:
		background-color 0.3s,
		color 0.3s;
}
.locationButtonPicker_FbjEm {
	display: flex;
	align-items: center;
	padding: 6px 12px;
	min-width: 100px;
	border: 1px solid #ddd;
	justify-content: center;
	border-radius: 8px;
	background-color: white;
	font-size: 14px;
	color: var(--e6fff9-background);
	cursor: pointer;
	font-weight: bold;
	transition:
		background-color 0.3s,
		color 0.3s;
}

.locationButton_ppm0j:hover {
	background-color: #f0f0f0;
}

.locationButtonActive_lzbo1 {
	border-color: #d2d2d2;
	color: #333;
}

.locationIcon_QR093 {
	margin-right: 5px;
}

.locationIconDropdown_bc2_W {
	margin-left: 5px;
}
.descriptionMultiLineInputContainer_d8GkV {
	display: flex;
	align-items: center;
	background-color: var(--f5-background);
	border-radius: 7px;
	padding: 5px;
	align-items: flex-start;
	height: 110px;
	width: 100%;
	box-sizing: border-box;
}
.descriptionContainer_sgxwe {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 12px;
}
.myTasks_id9pT {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 10px;
}
.rejectMeetings_lxZb7 {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.rejectMeetings_lxZb7 span {
	margin-left: 8px;
}

.additionalOptions__K2rn {
	margin-top: 16px;
	display: flex;
	margin-left: 30px;
	flex-direction: column;
	gap: 12px;
}

.option_c7kAJ {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.option_c7kAJ span {
	margin-left: 8px;
}
.messageContainer_k3BC4 {
	display: flex;
	flex-direction: column;
}

.availabilityContainer_aMZrl {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	flex-direction: row;
}

.messageContainer_k3BC4 span {
	font-size: 14px;
	margin-bottom: 4px;
}


.dontBotherWrapper_nOebB {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 10px;
}
.noBotherText_Ii4ic {
	font-size: 17px;
	display: flex;
	gap: 6px;
	align-items: center;
	justify-content: flex-start;

	svg {
		margin-bottom: 3px;
	}
}
.silenceSpan_TS4oB {
	font-size: 14px;
}
.descriptionTextarea_Wl52U {
	width: 100%;
	border: none !important;
	background: none !important;
	outline: none !important;
	resize: none;
	overflow: hidden;
	font-size: 14px;
	min-height: 90px;
	color: var(--text-secondary);
	font-family: Arial, sans-serif;
}
.infoWrapper_SBqlT {
	margin-left: -8px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	flex-direction: row;
	background: var(--f5-background);
	border-radius: 5px;
	padding: 8px;
	width: calc(100% + 8px);
}
.infoRight_ClwAK {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
}
.infoText_Z3jeQ {
	color: var(--text-secondary);
	font-size: 15px;
}
.howItWorksButton_jL9qa {
	cursor: pointer;
	color: var(--_10a37f-background);
	-webkit-user-select: none;
	        user-select: none;
	font-weight: 500;
}
.moreinfoButton_VRAYU {
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	color: var(--text-secondary);
	padding: 5px 10px;
	font-weight: 500;
}
.infoIconsContainer_FKyvL {
	display: flex;
	margin-top: 8px;
	align-items: center;
	justify-content: flex-start;
	gap: 10px;
	flex-direction: row;
}
.divisionLine_EjEaI {
	width: calc(100% - 30px);
	height: 2px;
	background-color: var(--f5-background);
	z-index: 1000000;
	margin-left: 30px;
}


.addGuestsContainer_qu75y {
	align-items: center;
	display: flex;
	justify-content: flex-start;
	flex-direction: row;
	gap: 10px;
	height: 35px;
	position: relative;
}
.addGuestsInputWrapper_jlzVa {
	display: flex;
	align-items: center;
	width: 400px;
	min-width: 400px;
	justify-content: flex-start;
	min-height: 35px;
	height: 35px;
	max-height: 35px;
	height: 100%;
	position: relative;
}

.addGuestsInput__YXzT {
	border: none;
	outline: none;
	padding-left: 10px;
	width: 100%;
	border-radius: 4px;
	background-color: var(--f5-background);
	height: 100%;
	font-size: 16px;
}
.initial_vr6rd {
	font-size: 18px;
	color: white;
	background-color: #4285f4;
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
}

.invitedUsersContainer_O2_SF {
	width: 270px;
	min-height: 63px;
	max-height: 100px;
	overflow-y: auto;
	margin-left: 30px;
	display: flex;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	gap: 4px;
}

.invitedUserCard_nnDhk {
	display: flex;
	padding: 0px 8px;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 35px;
	gap: 10px;
	font-size: 15px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	border-radius: 4px;
	position: relative;
}

.invitedUserCard_nnDhk:hover {
	background: var(--_16c0982e-background);
}

.closeButtonContainer_niiJC {
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	visibility: hidden;
}

.invitedUserCard_nnDhk:hover .closeButtonContainer_niiJC {
	visibility: visible;
}

.closeButton_tiZWZ {
	color: var(--color-text);
	font-size: 18px;
	cursor: pointer;
	padding: 2px;
	border-radius: 50%;
}

.closeButton_tiZWZ:hover {
	background-color: var(--_16c098-color);
}

.tooltip_LSNkQ {
	visibility: hidden;
	background-color: #666;
	color: #fff;
	text-align: center;
	padding: 4px 8px;
	border-radius: 4px;
	position: absolute;
	top: -12px;
	left: -65px;
	margin-top: 8px;
	white-space: nowrap;
	z-index: 1;
	font-size: 12px;
}

.closeButtonContainer_niiJC:hover .tooltip_LSNkQ {
	visibility: visible;
}

.inputContainer_MHy4B {
	display: flex;
	height: 35px;
	border-radius: 4px 4px 0px 0px;
	width: 400px;
	position: relative;
	align-items: center;
	justify-content: center;
	background: var(--f5-background);
}

.input_ujwmA {
	width: 100%;
	padding: 4px 6px;
	border: none;
	border-bottom: 2px solid #d1d1d1;
	outline: none;
	height: 100%;
	font-size: 14px;
	background: transparent;
	font-weight: 500;
	color: #6e6e6e;
}

.input_ujwmA::placeholder {
	color: #6e6e6e;
}

.underline_gWsIn {
	position: absolute;
	bottom: 0;
	width: 0;
	width: 0%;
	height: 2px;
	background: var(--_16c098-color);
	transition: width 0.3s ease;
}

.focused_qgSyY {
	border-bottom-color: transparent;
}

.active_xIDuz {
	width: 100%;
}


.iconFacturaGPT_jBt6p{
	stroke: black;
		height: 20px;
		width: 20px;
		margin-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/EventTypes.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;CACtB,UAAU;CACV,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,iBAAiB;CACjB,2BAA2B;AAC5B;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,kBAAkB;CAClB,gCAAgC;AACjC;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR;EACC,aAAa;EACb,sBAAsB;CACvB;CACA;EACC,eAAe;EACf,iBAAiB;EACjB,4BAA4B;CAC7B;AACD;AACA;CACC;EACC,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;AACD;;;;AAIA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT;EACC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;CACb;CACA;EACC,WAAW;EACX,YAAY;EACZ,mBAAmB;CACpB;AACD;AACA;CACC,gCAAgC;CAChC,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,uCAAuC;CACvC;EACC,6CAA6C;CAC9C;AACD;AACA;CACC,qCAAqC;CACrC,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,uCAAuC;CACvC;EACC,2CAA2C;CAC5C;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR;EACC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;CACb;CACA;EACC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;CACnB;AACD;;;;AAIA;CACC,aAAa;CACb,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB;;YAEW;AACZ;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,+BAA+B;CAC/B,eAAe;CACf,iBAAiB;CACjB;;YAEW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,sCAAsC;CACtC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,aAAa;CACb,WAAW;CACX,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,SAAS;AACV;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;AACV;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,iBAAiB;CACjB,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;AACV;AACA;CACC,eAAe;CACf,aAAa;CACb,QAAQ;CACR,mBAAmB;CACnB,2BAA2B;;CAE3B;EACC,kBAAkB;CACnB;AACD;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,uBAAuB;CACvB,2BAA2B;CAC3B,wBAAwB;CACxB,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,4BAA4B;CAC5B,8BAA8B;AAC/B;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,mBAAmB;CACnB,gCAAgC;CAChC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;AACvB;AACA;CACC,4BAA4B;CAC5B,eAAe;AAChB;AACA;CACC,eAAe;CACf,gCAAgC;CAChC,yBAAiB;SAAjB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,4BAA4B;CAC5B,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,wBAAwB;CACxB,WAAW;CACX,sCAAsC;CACtC,gBAAgB;CAChB,iBAAiB;AAClB;;;AAGA;CACC,mBAAmB;CACnB,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,2BAA2B;CAC3B,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,sCAAsC;CACtC,YAAY;CACZ,eAAe;AAChB;AACA;CACC,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,SAAS;CACT,eAAe;CACf,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,gCAAgC;CAChC,aAAa;CACb,YAAY;CACZ,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;;AAGA;CACC,aAAa;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;AACjB","sourcesContent":[".eventTypeContentContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\twidth: 95%;\n\tmargin-left: 2.5%;\n\tgap: 13px;\n}\n.normalIcon {\n\tcolor: var(--_3c3a3a-color);\n}\n.infoIconTop {\n\tmargin-top: -40px;\n\tcolor: var(--_3c3a3a-color);\n}\n.columnContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 5px;\n\tposition: relative;\n}\n.meetLink {\n\tposition: absolute;\n\ttop: 43px;\n\tleft: 0;\n\twidth: max-content;\n\tcolor: var(--_16c098-background);\n}\n.formTime {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 5px;\n\t.innerContainer {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\tspan {\n\t\tfont-size: 12px;\n\t\tmargin-left: 10px;\n\t\tcolor: var(--text-secondary);\n\t}\n}\n.formCalendar {\n\tbutton {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\toutline: none;\n\t\tcolor: var(--_10a37f-background);\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-left: 30px;\n\t}\n}\n\n\n\n.formMeet {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tsvg {\n\t\tmin-width: 10px;\n\t\tmin-height: 10px;\n\t\twidth: 10px;\n\t\theight: 10px;\n\t}\n\tdiv svg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tmargin-right: -13px;\n\t}\n}\n.meetButton {\n\tbackground: var(--f5-background);\n\tcolor: var(--text-color-secondary);\n\tpadding: 8px 14px;\n\tborder-radius: 6px;\n\ttransition: background 0.2s ease-in-out;\n\t&:hover {\n\t\tbackground-color: var(--_16c0982e-background);\n\t}\n}\n.meetButtonActive {\n\tbackground: var(--_10a37f-background);\n\tcolor: var(--_16c0982e-background);\n\tpadding: 8px 14px;\n\tborder-radius: 6px;\n\ttransition: background 0.2s ease-in-out;\n\t&:hover {\n\t\tbackground-color: var(--_16c098-background);\n\t}\n}\n.formLocation {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 9px;\n\tsvg {\n\t\tmin-width: 22px;\n\t\tmin-height: 22px;\n\t\twidth: 22px;\n\t\theight: 22px;\n\t}\n\tbutton {\n\t\tbackground: var(--border-color);\n\t\tpadding: 4px 12px;\n\t\tborder-radius: 4px;\n\t}\n}\n\n\n\n.locationContainer {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-left: 30px;\n}\n\n.locationButton {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 6px 12px;\n\tborder: 1px solid #ddd;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tbackground-color: white;\n\tfont-size: 14px;\n\tcolor: #666;\n\tcursor: pointer;\n\tfont-weight: 600;\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tcolor 0.3s;\n}\n.locationButtonPicker {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 6px 12px;\n\tmin-width: 100px;\n\tborder: 1px solid #ddd;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tbackground-color: white;\n\tfont-size: 14px;\n\tcolor: var(--e6fff9-background);\n\tcursor: pointer;\n\tfont-weight: bold;\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tcolor 0.3s;\n}\n\n.locationButton:hover {\n\tbackground-color: #f0f0f0;\n}\n\n.locationButtonActive {\n\tborder-color: #d2d2d2;\n\tcolor: #333;\n}\n\n.locationIcon {\n\tmargin-right: 5px;\n}\n\n.locationIconDropdown {\n\tmargin-left: 5px;\n}\n.descriptionMultiLineInputContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: var(--f5-background);\n\tborder-radius: 7px;\n\tpadding: 5px;\n\talign-items: flex-start;\n\theight: 110px;\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n.descriptionContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 100%;\n\tgap: 12px;\n}\n.myTasks {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 10px;\n}\n.rejectMeetings {\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n}\n\n.rejectMeetings span {\n\tmargin-left: 8px;\n}\n\n.additionalOptions {\n\tmargin-top: 16px;\n\tdisplay: flex;\n\tmargin-left: 30px;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.option {\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n}\n\n.option span {\n\tmargin-left: 8px;\n}\n.messageContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.availabilityContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 12px;\n\tflex-direction: row;\n}\n\n.messageContainer span {\n\tfont-size: 14px;\n\tmargin-bottom: 4px;\n}\n\n\n.dontBotherWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 10px;\n}\n.noBotherText {\n\tfont-size: 17px;\n\tdisplay: flex;\n\tgap: 6px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\n\tsvg {\n\t\tmargin-bottom: 3px;\n\t}\n}\n.silenceSpan {\n\tfont-size: 14px;\n}\n.descriptionTextarea {\n\twidth: 100%;\n\tborder: none !important;\n\tbackground: none !important;\n\toutline: none !important;\n\tresize: none;\n\toverflow: hidden;\n\tfont-size: 14px;\n\tmin-height: 90px;\n\tcolor: var(--text-secondary);\n\tfont-family: Arial, sans-serif;\n}\n.infoWrapper {\n\tmargin-left: -8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 12px;\n\tflex-direction: row;\n\tbackground: var(--f5-background);\n\tborder-radius: 5px;\n\tpadding: 8px;\n\twidth: calc(100% + 8px);\n}\n.infoRight {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n.infoText {\n\tcolor: var(--text-secondary);\n\tfont-size: 15px;\n}\n.howItWorksButton {\n\tcursor: pointer;\n\tcolor: var(--_10a37f-background);\n\tuser-select: none;\n\tfont-weight: 500;\n}\n.moreinfoButton {\n\tcursor: pointer;\n\tuser-select: none;\n\tcolor: var(--text-secondary);\n\tpadding: 5px 10px;\n\tfont-weight: 500;\n}\n.infoIconsContainer {\n\tdisplay: flex;\n\tmargin-top: 8px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 10px;\n\tflex-direction: row;\n}\n.divisionLine {\n\twidth: calc(100% - 30px);\n\theight: 2px;\n\tbackground-color: var(--f5-background);\n\tz-index: 1000000;\n\tmargin-left: 30px;\n}\n\n\n.addGuestsContainer {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tgap: 10px;\n\theight: 35px;\n\tposition: relative;\n}\n.addGuestsInputWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 400px;\n\tmin-width: 400px;\n\tjustify-content: flex-start;\n\tmin-height: 35px;\n\theight: 35px;\n\tmax-height: 35px;\n\theight: 100%;\n\tposition: relative;\n}\n\n.addGuestsInput {\n\tborder: none;\n\toutline: none;\n\tpadding-left: 10px;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tbackground-color: var(--f5-background);\n\theight: 100%;\n\tfont-size: 16px;\n}\n.initial {\n\tfont-size: 18px;\n\tcolor: white;\n\tbackground-color: #4285f4;\n\twidth: 30px;\n\theight: 30px;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n}\n\n.invitedUsersContainer {\n\twidth: 270px;\n\tmin-height: 63px;\n\tmax-height: 100px;\n\toverflow-y: auto;\n\tmargin-left: 30px;\n\tdisplay: flex;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.invitedUserCard {\n\tdisplay: flex;\n\tpadding: 0px 8px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\twidth: 100%;\n\theight: 35px;\n\tgap: 10px;\n\tfont-size: 15px;\n\tcursor: pointer;\n\tuser-select: none;\n\tborder-radius: 4px;\n\tposition: relative;\n}\n\n.invitedUserCard:hover {\n\tbackground: var(--_16c0982e-background);\n}\n\n.closeButtonContainer {\n\tmargin-left: auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\tvisibility: hidden;\n}\n\n.invitedUserCard:hover .closeButtonContainer {\n\tvisibility: visible;\n}\n\n.closeButton {\n\tcolor: var(--color-text);\n\tfont-size: 18px;\n\tcursor: pointer;\n\tpadding: 2px;\n\tborder-radius: 50%;\n}\n\n.closeButton:hover {\n\tbackground-color: var(--_16c098-color);\n}\n\n.tooltip {\n\tvisibility: hidden;\n\tbackground-color: #666;\n\tcolor: #fff;\n\ttext-align: center;\n\tpadding: 4px 8px;\n\tborder-radius: 4px;\n\tposition: absolute;\n\ttop: -12px;\n\tleft: -65px;\n\tmargin-top: 8px;\n\twhite-space: nowrap;\n\tz-index: 1;\n\tfont-size: 12px;\n}\n\n.closeButtonContainer:hover .tooltip {\n\tvisibility: visible;\n}\n\n.inputContainer {\n\tdisplay: flex;\n\theight: 35px;\n\tborder-radius: 4px 4px 0px 0px;\n\twidth: 400px;\n\tposition: relative;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: var(--f5-background);\n}\n\n.input {\n\twidth: 100%;\n\tpadding: 4px 6px;\n\tborder: none;\n\tborder-bottom: 2px solid #d1d1d1;\n\toutline: none;\n\theight: 100%;\n\tfont-size: 14px;\n\tbackground: transparent;\n\tfont-weight: 500;\n\tcolor: #6e6e6e;\n}\n\n.input::placeholder {\n\tcolor: #6e6e6e;\n}\n\n.underline {\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 0;\n\twidth: 0%;\n\theight: 2px;\n\tbackground: var(--_16c098-color);\n\ttransition: width 0.3s ease;\n}\n\n.focused {\n\tborder-bottom-color: transparent;\n}\n\n.active {\n\twidth: 100%;\n}\n\n\n.iconFacturaGPT{\n\tstroke: black;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t\tmargin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eventTypeContentContainer": `eventTypeContentContainer_zY91Z`,
	"normalIcon": `normalIcon_Qw66q`,
	"infoIconTop": `infoIconTop_g3mau`,
	"columnContainer": `columnContainer_LQIaE`,
	"meetLink": `meetLink_Hw19T`,
	"formTime": `formTime_xPcaw`,
	"innerContainer": `innerContainer_Xs2_J`,
	"formCalendar": `formCalendar_mChgy`,
	"formMeet": `formMeet_JoQ0x`,
	"meetButton": `meetButton_k_7pm`,
	"meetButtonActive": `meetButtonActive_FaR8S`,
	"formLocation": `formLocation_eaVs_`,
	"locationContainer": `locationContainer_FKoG9`,
	"locationButton": `locationButton_ppm0j`,
	"locationButtonPicker": `locationButtonPicker_FbjEm`,
	"locationButtonActive": `locationButtonActive_lzbo1`,
	"locationIcon": `locationIcon_QR093`,
	"locationIconDropdown": `locationIconDropdown_bc2_W`,
	"descriptionMultiLineInputContainer": `descriptionMultiLineInputContainer_d8GkV`,
	"descriptionContainer": `descriptionContainer_sgxwe`,
	"myTasks": `myTasks_id9pT`,
	"rejectMeetings": `rejectMeetings_lxZb7`,
	"additionalOptions": `additionalOptions__K2rn`,
	"option": `option_c7kAJ`,
	"messageContainer": `messageContainer_k3BC4`,
	"availabilityContainer": `availabilityContainer_aMZrl`,
	"dontBotherWrapper": `dontBotherWrapper_nOebB`,
	"noBotherText": `noBotherText_Ii4ic`,
	"silenceSpan": `silenceSpan_TS4oB`,
	"descriptionTextarea": `descriptionTextarea_Wl52U`,
	"infoWrapper": `infoWrapper_SBqlT`,
	"infoRight": `infoRight_ClwAK`,
	"infoText": `infoText_Z3jeQ`,
	"howItWorksButton": `howItWorksButton_jL9qa`,
	"moreinfoButton": `moreinfoButton_VRAYU`,
	"infoIconsContainer": `infoIconsContainer_FKyvL`,
	"divisionLine": `divisionLine_EjEaI`,
	"addGuestsContainer": `addGuestsContainer_qu75y`,
	"addGuestsInputWrapper": `addGuestsInputWrapper_jlzVa`,
	"addGuestsInput": `addGuestsInput__YXzT`,
	"initial": `initial_vr6rd`,
	"invitedUsersContainer": `invitedUsersContainer_O2_SF`,
	"invitedUserCard": `invitedUserCard_nnDhk`,
	"closeButtonContainer": `closeButtonContainer_niiJC`,
	"closeButton": `closeButton_tiZWZ`,
	"tooltip": `tooltip_LSNkQ`,
	"inputContainer": `inputContainer_MHy4B`,
	"input": `input_ujwmA`,
	"underline": `underline_gWsIn`,
	"focused": `focused_qgSyY`,
	"active": `active_xIDuz`,
	"iconFacturaGPT": `iconFacturaGPT_jBt6p`
};
export default ___CSS_LOADER_EXPORT___;
